import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/state/app.state';
import * as RefNoActions from '../../store/actions/reference-number.actions';
import * as HealthRecordsActions from '../../store/actions/health-records.actions';
import * as beneficiaryDetailsActions from '../../store/actions/beneficiary-details.actions';
import * as ClearToApplyActions from '../../store/actions/clear-to-apply.actions';
import * as DepHealthRecordsActions from '../../store/actions/dep-health-records.actions';
import * as paymentDetailsActions from '../../store/actions/payment-details.actions';
import * as yourDependantDetailsActions from '../../store/actions/your-dependant-details.actions';
import * as YourPensionSavings from '../../store/actions/your-pension-savings.actions';
import * as yourPersonalDetailsActions from '../../store/actions/your-personal-details.actions';
import * as yourProductApplicationActions from '../../store/actions/your-product-application.actions';
import * as YourLumpSumActions from '../../store/actions/your-lump-sum-allowances.actions';

@Injectable({
    providedIn: 'root'
})
export class StoreService {

    constructor(private store: Store<AppState>) { }

    resetApplyStore() {
        this.store.dispatch(new ClearToApplyActions.RemoveClearToApply(0));
        this.store.dispatch(new yourPersonalDetailsActions.RemoveYourPersonalDetails(0));
        this.store.dispatch(new HealthRecordsActions.RemoveHealthRecords(0));
        this.store.dispatch(new yourDependantDetailsActions.RemoveYourDependantDetails(0));
        this.store.dispatch(new DepHealthRecordsActions.RemoveDepHealthRecords(0));
        this.store.dispatch(new YourPensionSavings.RemovePensionSavings(0));
        this.store.dispatch(new beneficiaryDetailsActions.RemoveBeneficiaryDetails(0));
        this.store.dispatch(new paymentDetailsActions.RemovePaymentDetails(0));
        this.store.dispatch(new yourProductApplicationActions.RemoveYourProductApplication(0));
    }
}